<template>
  <div></div>
</template>

<script>
export default {
  name: 'AttachmentWasDeleted',
}
</script>
